import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function AccessDenied() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="flex justify-center">
          <Shield className="h-12 w-12 text-red-500" />
        </div>
        <h1 className="text-4xl font-bold mb-4">Access Denied</h1>
        <p className="text-lg mb-8">You don&apos;t have permission to access this page.</p>
        <Link to="/" className="text-blue-600 hover:text-blue-800">Go Back Home</Link>
      </div>
    </div>
  );
} 